/**
 * One appearance for every Clerk surface.
 *
 * <SignIn> and <SignUp> are two renders of the same card, and Clerk's own
 * "sign up" / "sign in" links move between them. Keeping the theme in one place
 * means the second page cannot drift from the first: the variables carry the
 * rose accent, the cream input surface and the rounded corners into Clerk's own
 * styles, and the elements take the card's chrome off so the page is one card
 * rather than a card inside a card.
 *
 * The class names are this app's, passed through `appearance.elements`; they
 * live in app.css next to .auth-card and do not depend on Clerk's internals.
 */
export const clerkAppearance = {
  variables: {
    colorPrimary: "#e0447e",
    colorPrimaryForeground: "#ffffff",
    colorForeground: "var(--text)",
    colorMutedForeground: "var(--muted)",
    colorBackground: "transparent",
    colorInput: "var(--bg)",
    colorInputForeground: "var(--text)",
    colorBorder: "var(--border)",
    colorNeutral: "var(--text)",
    colorRing: "rgb(224 68 126 / 20%)",
    borderRadius: "8px",
    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
    fontSize: "15px",
  },
  elements: {
    rootBox: "auth-clerk-root",
    cardBox: "auth-clerk-cardbox",
    card: "auth-clerk-card",
    header: "auth-clerk-header",
    formButtonPrimary: "auth-clerk-primary",
    socialButtonsBlockButton: "auth-clerk-social",
  },
} as const;

/** Where Clerk sends a visitor once it has a session. */
export const AUTH_REDIRECT_URL = "/dashboard";
